<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm8>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="logo">MFP</div>
            </v-flex>
            <v-flex xs12>
              <h2>ログイン</h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-text-field type="text" label="Email" v-model="email" />
          <v-text-field type="password" label="Password" v-model="password" /> {{errorMessage}}
        </v-card-text>
        <v-card-actions>
         <router-link :to="{name:'reset_password', params:{company_id:this.$route.params.company_id}}">パスワードの再設定</router-link>
          <v-spacer />
          <v-btn @click="logIn">ログイン</v-btn>

        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from '@/components/fireAuthInit'
import db from '@/components/firebaseInit'
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
export default {
  data() {    return {
      email: "",
      password: "",
      company: {}
    }
  },
  mounted() {
  },
  methods: {
    logIn() {
      const { email, password } = this
      
      this.$store.dispatch('auth/logIn', { email, password, company_id: this.$route.params.company_id })
        .then(() => {
          
          //this.$router.push({name:'home', params:{company_id: this.$route.params.company_id}})
        }
        )
    },
    resetPassword(){
      
      auth.sendPasswordResetEmail(this.email)

    }
    // ...mapMutations('app', ['changeLoadingState'])
  },
  computed: {
    ...mapState('auth', ["errorMessage"]),
    ...mapGetters('auth', ["user"])

  }
}
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>

